const listener = {
  multiPack: (multiPackElement, event, target) => {
    $(document).on(event, target, (e) => {
      const $trigger = $(e.currentTarget);
      const $scope = $trigger.closest('.product-detail').length ? $trigger.closest('.product-detail') : $(document);
      const $multiPackItems = $scope.find(multiPackElement);
      let foundCompatibleMatch = false;

      if (multiPackElement) {
        const currentQty = parseInt($(e.currentTarget).val(), 10);
        let bestQty = -1;
        let $bestMatch = $();

        $multiPackItems.each((index, el) => {
          const optionQty = parseInt($(el).data('quantity'), 10);
          if (!isNaN(optionQty) && !isNaN(currentQty) && optionQty <= currentQty && optionQty > bestQty) {
            bestQty = optionQty;
            $bestMatch = $(el);
          }
        });

        if ($bestMatch.length) {
          $bestMatch.addClass('is-active');
          $multiPackItems.not($bestMatch).removeClass('is-active');
          foundCompatibleMatch = true;
        }

        // If no compatible match, deactivate all multipack items.
        if (!foundCompatibleMatch) {
          $multiPackItems.removeClass('is-active');
        }
      }

      const $activeCell = $scope.find('.multi-pack-items.is-active').first();
      let $unitPriceContainer = $scope.find('.has-multipack-price').first();

      if (!$unitPriceContainer.length) {
        const $fallbackPrices = $scope.find('.details-container .prices').first();
        if ($fallbackPrices.length) {
          $fallbackPrices.addClass('has-multipack-price');
          $unitPriceContainer = $fallbackPrices;
        }
      }

      const $unitPriceValue = $unitPriceContainer.find('.sales .value').first().length
        ? $unitPriceContainer.find('.sales .value').first()
        : $unitPriceContainer.find('.value').first();

      if ($unitPriceContainer.length && $unitPriceValue.length && !$unitPriceContainer.attr('data-base-unit-price')) {
        $unitPriceContainer.attr('data-base-unit-price', $unitPriceValue.text());
        $unitPriceContainer.attr('data-base-unit-content', $unitPriceValue.attr('content') || '');
      }

      if ($activeCell.length && $unitPriceContainer.length && $unitPriceValue.length) {
        const unitPrice = $activeCell.attr('data-unitprice');
        const unitContent = $activeCell.attr('data-unit-content');

        $unitPriceValue.text(unitPrice);
        $unitPriceValue.attr('content', unitContent);
        $unitPriceContainer.removeClass('d-none');
      } else if ($unitPriceContainer.length && $unitPriceValue.length) {
        // No exact match - reset to base unit price
        const baseUnitPrice = $unitPriceContainer.attr('data-base-unit-price');
        const baseUnitContent = $unitPriceContainer.attr('data-base-unit-content');

        if (baseUnitPrice !== undefined) {
          $unitPriceValue.text(baseUnitPrice);
        }
        if (baseUnitContent !== undefined) {
          $unitPriceValue.attr('content', baseUnitContent);
        }

        $unitPriceContainer.removeClass('d-none');
      }
    });
  },
  sticky: (element, event) => {
    $(window).on(event, () => {
      const $this = $(element);

      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - $this.height()) {
        $this.addClass('is-hide');
      } else {
        if ($this.find('.btn:visible').length === 0) return;
        $this.removeClass('is-hide');
      }
    });
  },
  setStickyDisplay: (element, displayBreakpoint) => {
    if (!element) return;
    element.classList.add('show');
    const page = document.getElementsByClassName('page')[0];
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize && entry.contentBoxSize[0].inlineSize <= displayBreakpoint && window.innerWidth <= displayBreakpoint) {
          const elementHeight = element.getBoundingClientRect().height;
          page.style.setProperty('padding-bottom', `${elementHeight}px`);
        } else {
          page.style.paddingBottom = '';
        }
      }
    });

    resizeObserver.observe(element);
  },
  shippingMethod: (container, elementList, row) => {
    elementList.find('input[type=radio]').each((i, el) => {
      const $this = $(el);
      const methodID = $($this).is(':checked');
      const form = container.find('.shipping-form');

      const $shippingSection = container.find('.shipping-section .shipping-address-block');
      const $shippingSummary = container.find('.shipping-summary');
      const $labelShippingSection = $shippingSection.find('.card-header-custom');
      const $labelShippingSummary = $shippingSummary.find('.shipping-addr-label');
      const shippingTextChanged = $shippingSection.find('.card-header-custom').attr('data-text-changed');

      if (methodID && el.defaultValue === 'idt-pickup-in-store') {
        row.addClass('is-active');
        $labelShippingSection.text(shippingTextChanged);
        $labelShippingSummary.text(shippingTextChanged);
        $('input[name$=_shippingAddressUseAsBillingAddress]', form).prop('checked', true);
        $('body').trigger('checkout:disableButton', '.next-step-button button');

        setTimeout(() => {
          row.addClass('is-visible');
        }, 200);
      }
    });
  },
  paymentTab: (listPaymentElement, selectedShippingMethod) => {
    $(listPaymentElement).addClass('d-none');

    if (selectedShippingMethod === 'idt-cash-on-delivery' || selectedShippingMethod === 'idt-cash-on-delivery-isole') {
      $('[data-shipping-method-id="CASH_ON_DELIVERY"]').removeClass('d-none');
    } else {
      $('[data-shipping-method-id="null"]').removeClass('d-none');
    }

    $(listPaymentElement).not('.d-none').first().find('a').trigger('click');
  },
  dataLayerAddToCartHandler: (category) => {
    // State lives on window: the bundles (main, homePage, ...) each embed their own copy of this module
    window.addToCartDataLayerState = window.addToCartDataLayerState || { isRegistered: false, category: [] };
    const state = window.addToCartDataLayerState;

    if (category && category.length) {
      state.category = category;
    }

    if (state.isRegistered) {
      return;
    }

    state.isRegistered = true;

    $('body').on('updateAddToCartFormData', (e, form) => {
      if ($(e.target).hasClass('js-recommended-product-set-add-to-cart')) {
        form.isRecommendedProductSet = true;
      }
    });

    // "+" / "−" of the quantity counter shown on the tile after the first add: only the changed units are tracked
    const getTileProduct = (data) => {
      // Cart and minicart lines carry the product data on their remove button, tiles on the .product element
      const $line = data.source === 'line' && data.$input ? data.$input.closest('.card').find('.remove-product').first() : $();
      const $tile = $(`.product[data-pid="${data.productID}"]`).first();
      const $wrapper = $line.length ? $line : $tile.length ? $tile : $(`.remove-product[data-pid="${data.productID}"]`).first();

      return {
        name: $wrapper.attr('data-name'),
        id: $wrapper.attr('data-pid'),
        price: $wrapper.attr('data-price'),
        brand: $wrapper.attr('data-brand'),
        quantity: data.quantity
      };
    };

    $('body').on('product:afterIncreaseQuantity', (e, data) => {
      const dataLayerProduct = [getTileProduct(data)];
      const addToCartCategory = window.addToCartDataLayerState.category;

      for (let i = 0; i < addToCartCategory.length; i++) {
        dataLayerProduct['item_category' + (i > 0 ? i + 1 : '')] = addToCartCategory[i];
      }

      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          add: {
            products: dataLayerProduct
          }
        },
        add_to_cart_origin: 'addToCart'
      });
    });

    $('body').on('product:afterDecreaseQuantity', (e, data) => {
      dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          remove: {
            products: [{ ...getTileProduct(data), category: '' }]
          }
        }
      });
    });

    $('body').on('product:afterAddToCart', (e, response) => {
      let $wrapper;
      let quantity = 0;
      const dataLayerProduct = [];
      const $container = $(`.container.product-detail[data-pid="${response.productID}"]`);

      if (!response.error) {
        if ($container.length > 0) {
          $wrapper = $container;
          quantity = parseInt($container.find('.input-quantity').first().val(), 10) || 1;
        } else {
          $wrapper = $(`.product[data-pid="${response.productID}"]`).first();
          quantity = 1;
        }

        if (response.isGlobalAddToCart) {
          response.productsAdded.forEach((product) => {
            dataLayerProduct.push({
              name: product.name,
              id: product.pid,
              price: product.price,
              brand: product.brand,
              quantity: parseInt(product.qty) || 1
            });
          });
        } else {
          dataLayerProduct.push({
            name: $wrapper.attr('data-name'),
            id: $wrapper.attr('data-pid'),
            price: $wrapper.attr('data-price'),
            brand: $wrapper.attr('data-brand'),
            quantity: quantity
          });
        }

        const addToCartCategory = window.addToCartDataLayerState.category;

        for (let i = 0; i < addToCartCategory.length; i++) {
          dataLayerProduct['item_category' + (i > 0 ? i + 1 : '')] = addToCartCategory[i];
        }

        const addAllOrigin = response.isRecommendedProductSet ? 'productBundle_section' : 'productSet_page';

        dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            add: {
              products: dataLayerProduct
            }
          },
          add_to_cart_origin: response.isGlobalAddToCart ? addAllOrigin : 'addToCart'
        });
      }
    });
  },
  dataLayerRemoveFromCartHandler: ($wrapper, $quantity) => {
    dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [
            {
              name: $wrapper.attr('data-name'),
              id: $wrapper.attr('data-pid'),
              price: $wrapper.attr('data-price'),
              brand: $wrapper.attr('data-brand'),
              category: '',
              quantity: parseInt($quantity.val())
            }
          ]
        }
      }
    });
  },
  dataLayerCheckoutHandler: ($items, event, step) => {
    const products = [];
    $items.each((index, elem) => {
      const productInfo = {
        name: $(elem).attr('data-name'),
        id: $(elem).attr('data-pid'),
        price: $(elem).attr('data-price'),
        brand: $(elem).attr('data-brand'),
        quantity: parseInt($(elem).attr('data-quantity'))
      };
      const categoryObj = $(elem).attr('data-category') ? JSON.parse($(elem).attr('data-category')) : null;
      if (categoryObj) {
        Object.keys(categoryObj).forEach(function (key) {
          productInfo[key] = categoryObj[key];
        });
      }
      products.push(productInfo);
    });

    dataLayer.push({
      event: event,
      ecommerce: {
        checkout: {
          actionField: { step: step },
          products: products
        }
      }
    });
  },
  dataLayerCheckoutStepExist: (index) => {
    return dataLayer.some((object) => {
      if (object.ecommerce) {
        return object.ecommerce.checkout.actionField.step === index;
      }

      return false;
    });
  },
  dataLayerLoginHandler: (customerNo) => {
    if (customerNo) {
      dataLayer.push({
        event: 'login',
        user_id: customerNo
      });
    }
  },
  dataLayerPurchaseHandler: ($invoice, $items) => {
    const products = [];
    $items.each((index, elem) => {
      const productInfo = {
        name: $(elem).attr('data-name'),
        id: $(elem).attr('data-pid'),
        price: $(elem).attr('data-price'),
        brand: $(elem).attr('data-brand'),
        quantity: parseInt($(elem).attr('data-quantity'))
      };
      const categoryObj = $(elem).attr('data-category') ? JSON.parse($(elem).attr('data-category')) : null;
      if (categoryObj) {
        Object.keys(categoryObj).forEach(function (key) {
          productInfo[key] = categoryObj[key];
        });
      }
      products.push(productInfo);
    });

    const newCustomerAttr = $invoice.attr('data-new-customer');
    const newCustomer = newCustomerAttr === 'true' ? true : newCustomerAttr === 'false' ? false : null;

    dataLayer.push({
      event: 'purchase',
      new_customer: newCustomer,
      enhanced_conversion_data: {
        email: $invoice.attr('data-order-email'),
        phone: $invoice.attr('data-order-phone-number')
      },
      ecommerce: {
        purchase: {
          actionField: {
            id: $invoice.attr('data-order-number'),
            revenue: $invoice.attr('data-revenue'),
            tax: $invoice.attr('data-tax'),
            shipping: $invoice.attr('data-shipping-cost'),
            coupon: $invoice.attr('data-coupon')
          },
          products: products
        }
      }
    });
  }
};

export default listener;
